module.exports = ".modal-body {\n  padding: 1rem!important;\n}\n.modal-body p {\n  margin-bottom: 0px;\n}\n.modal-footer {\n  padding-top: 1rem;\n}\n"